import { render, staticRenderFns } from "./GotedoSpinnerLoader.vue?vue&type=template&id=fab069c2"
import script from "./GotedoSpinnerLoader.vue?vue&type=script&lang=js"
export * from "./GotedoSpinnerLoader.vue?vue&type=script&lang=js"
import style0 from "./GotedoSpinnerLoader.vue?vue&type=style&index=0&id=fab069c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports